function getCodeMirrorOptions (type) {
  const options = {
    tabSize: 2,
    styleActiveLine: true,
    lineNumbers: true,
    styleSelectedText: true,
    line: true,
    foldGutter: true,
    gutters: [
      'CodeMirror-linenumbers',
      'CodeMirror-foldgutter'
    ],
    highlightSelectionMatches: {
      showToken: /\w/,
      annotateScrollbar: true
    },
    hintOptions: {
      completeSingle: true
    },
    keyMap: 'sublime',
    matchBrackets: true,
    showCursorWhenSelecting: true,
    extraKeys: {
      'Ctrl': 'autocomplete'
    },
  }

  switch (type) {
    case 'x-vue':
      options.mode = 'text/x-vue'
      break
    case 'text/css':
      options.mode = 'text/css'
      break
    case 'text/javascript':
      options.mode = 'text/javascript'
  }

  return options
}

export default {
  cmTemplateOptions: getCodeMirrorOptions('text/x-vue'),
  cmStylesOptions: getCodeMirrorOptions('text/css'),
  cmScriptOptions: getCodeMirrorOptions('text/javascript')
}